import React, { FunctionComponent, useCallback } from 'react';
import CustomPopover from '../../../../components/CustomPopover';
import TeamList from '../../../../containers/TeamList';
import { ITeam } from '../../../../common/models/team/ITeam';
import { connect } from 'react-redux';
import { changeUserTeamRoutine } from '../../routines';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { IUserTeam } from '../../../../common/models/user/IUserTeam';
import { IPopoverChild } from '../../../../common/models/common/IPopoverChild';
import { concat } from '../../../../common/helpers/arrayHelper';
import styles from './styles.module.scss';
import Icon from '../../../../components/Icon';

interface IProps {
  userId: string;
  selectedTeam: ITeam;
  disabled: boolean;
  changeUserTeam: IBindingCallback1<IUserTeam>;
}

const TeamPopup: FunctionComponent<IProps> = ({ selectedTeam, userId, disabled, changeUserTeam }) => {
  const Trigger = () => (
    <div className={concat('popup-trigger', styles.trigger, disabled ? 'trigger-disabled' : '')}>
      <span className="flex-grow-1 overflow-ellipsis">
        {selectedTeam.name}
      </span>
      <Icon icon="chevronDown" className="popup-chevron" />
    </div>
  );

  const onSelect = ([team]: ITeam[]) => changeUserTeam({ id: userId, team });

  const TeamListComponent = useCallback(({ hidePopover }: IPopoverChild) => (
    <TeamList
      selectedIds={[selectedTeam.id]}
      onSelect={data => {
        onSelect(data);
        if (hidePopover) {
          hidePopover();
        }
      }}
    />
  ), []);

  return (disabled
    ? <Trigger />
    : (
      <div className="popup-wrapper">
        <CustomPopover
          popoverClassName={styles.teamPopover}
          placement="bottom-start"
          trigger={<Trigger />}
          rootClose
        >
          <TeamListComponent />
        </CustomPopover>
      </div>
    )
  );
};

const mapDispachToProps = {
  changeUserTeam: changeUserTeamRoutine
};

export default connect(null, mapDispachToProps)(TeamPopup);
